import type { Workspace, WorkspaceRole } from '../../types/workspace'

export const EDU_DEMO_WORKSPACE_IDS = [
  'school-demo',
  'coaching-demo',
  'sports-academy-demo',
] as const

export type EduDemoWorkspaceId = (typeof EDU_DEMO_WORKSPACE_IDS)[number]

export const isEduDemoWorkspace = (workspaceId: unknown): workspaceId is EduDemoWorkspaceId => {
  return typeof workspaceId === 'string' && (EDU_DEMO_WORKSPACE_IDS as readonly string[]).includes(workspaceId)
}

/**
 * Returns true if the user is viewing a demo/preview workspace in READONLY mode.
 * In this mode, visitors are granted the Admin/Staff view of all education tabs,
 * but all mutations are strictly disabled/read-only (rejecting with PREVIEW_READ_ONLY).
 */
export const isEduDemoViewer = (
  workspace: Workspace | null | undefined,
  role: WorkspaceRole | null | undefined,
): boolean => {
  if (!workspace || !role) return false
  return Boolean(workspace.isPreview && isEduDemoWorkspace(workspace.id) && role === 'READONLY')
}
